import Vue from 'vue'
import App from './App.vue'
import router from './router.js'

import UIKit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

import 'uikit/dist/css/uikit.min.css'

UIKit.use(Icons)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
